import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import { GetVendorBranch, GetVendorBranchVariables } from '../../athena/types/GetVendorBranch';

export const GET_VENDOR_BRANCH = gql`
  query GetVendorBranch($id: String) {
    vendor {
      getVendorBranchByID(input: { id: $id }) {
        vendorBranch {
          id
          fenceId
          name
          status
          capabilities {
            capabilityType
            configuration {
              ... on OdProtosVendorsData_Capability_ConfigurationOneof_D1WConfiguration {
                d1wConfiguration {
                  maxD1wsPerDay
                  maxD1wsPerWeek
                }
              }
            }
          }
          organizationId
          organization {
            uuid
            email
            primaryPhone
          }
          vendor {
            id
            name
            createdAt
            branchIds
            compliance {
              complianceStatus
              workersCompExpires
              workersCompExempt
              autoInsuranceExpires
              generalLiabilityInsuranceExpires
            }
          }
        }
      }
    }
  }
`;

const useGetVendorBranch = (
  options?: QueryHookOptions<GetVendorBranch, GetVendorBranchVariables>,
) => useQuery<GetVendorBranch>(GET_VENDOR_BRANCH, options);

export default useGetVendorBranch;
